import React from 'react'

interface ProgressOverviewProps {
  preSubmittedCount: number
  postSubmittedCount: number
  totalAssignments: number
  overallProgress: number
}

export const ProgressOverview: React.FC<ProgressOverviewProps> = ({
  preSubmittedCount,
  postSubmittedCount,
  totalAssignments,
  overallProgress
}) => {
  const prePercent = totalAssignments > 0 ? (preSubmittedCount / totalAssignments) * 100 : 0
  const postPercent = totalAssignments > 0 ? (postSubmittedCount / totalAssignments) * 100 : 0

  return (
    <div style={{
      background: 'var(--bg-card, #ffffff)',
      border: '1px solid var(--border-color, rgba(0, 0, 0, 0.1))',
      borderRadius: '16px',
      padding: '24px',
      marginBottom: '24px',
      boxShadow: '0 4px 20px rgba(0,0,0,0.02)'
    }}>
      <h3 style={{ margin: '0 0 16px 0', fontSize: '18px', fontWeight: 600 }}>ความคืบหน้าการส่งคะแนนภาพรวม</h3>

      {/* Progress metrics bars */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
        {/* Pre-Test Progress */}
        <div>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px', fontSize: '14px' }}>
            <span style={{ fontWeight: 500 }}>การส่งคะแนน Pre-Test</span>
            <span style={{ color: 'var(--text-secondary, #64748b)' }}>
              {preSubmittedCount} / {totalAssignments} รายวิชา-ห้องเรียน ({prePercent.toFixed(1)}%)
            </span>
          </div>
          <div style={{
            height: '8px',
            background: 'var(--bg-muted, #f1f5f9)',
            borderRadius: '4px',
            overflow: 'hidden'
          }}>
            <div style={{
              width: `${prePercent}%`,
              height: '100%',
              background: 'linear-gradient(90deg, #3b82f6, #60a5fa)',
              borderRadius: '4px',
              transition: 'width 0.5s ease-out'
            }} />
          </div>
        </div>

        {/* Post-Test Progress */}
        <div>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px', fontSize: '14px' }}>
            <span style={{ fontWeight: 500 }}>การส่งคะแนน Post-Test</span>
            <span style={{ color: 'var(--text-secondary, #64748b)' }}>
              {postSubmittedCount} / {totalAssignments} รายวิชา-ห้องเรียน ({postPercent.toFixed(1)}%)
            </span>
          </div>
          <div style={{
            height: '8px',
            background: 'var(--bg-muted, #f1f5f9)',
            borderRadius: '4px',
            overflow: 'hidden'
          }}>
            <div style={{
              width: `${postPercent}%`,
              height: '100%',
              background: 'linear-gradient(90deg, #10b981, #34d399)',
              borderRadius: '4px',
              transition: 'width 0.5s ease-out'
            }} />
          </div>
        </div>

        {/* Overall Completion Meter */}
        <div style={{
          borderTop: '1px solid var(--border-color, rgba(0,0,0,0.1))',
          paddingTop: '16px',
          marginTop: '8px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <div>
            <h4 style={{ margin: 0, fontSize: '15px', fontWeight: 600 }}>ความสำเร็จสะสมของกลุ่มสาระ</h4>
            <p style={{ margin: '4px 0 0 0', fontSize: '12px', color: 'var(--text-secondary, #64748b)' }}>
              คำนวณจากสัดส่วนการส่งคะแนนที่สมบูรณ์ครบถ้วนทั้ง Pre และ Post
            </p>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <div style={{ fontSize: '28px', fontWeight: 800, color: 'var(--primary-color, #3b82f6)' }}>
              {overallProgress.toFixed(1)}%
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
